import { ItemCarouselSourceType, ItemCarouselWidget } from "./item-carousel-widget";
import { normalizeTrailingSlash } from 'JS/utilities/url';
import { StoryCarouselWidget } from "./story-carousel-widget";
import { WidgetType } from "./base";

export type StoryAndItemCarouselLink = {
	url: string;
	text: string;
}

export function getStoryOrItemCarouselLink(widget: StoryCarouselWidget | ItemCarouselWidget): StoryAndItemCarouselLink | null {
	if (widget.type === WidgetType.StoryCarouselWidget) {
		const { linkText, linkUrl } = widget;

		if (!linkText || !linkUrl) {
			return null;
		}

		return {
			url: normalizeTrailingSlash(linkUrl),
			text: linkText,
		};
	}

	if (widget.source.type !== ItemCarouselSourceType.ProductListUrl) {
		return null;
	}

	return {
		url: normalizeTrailingSlash(widget.source.landingPageUrl),
		text: widget.linkText
	};
}